import { render, staticRenderFns } from "./VerticalVideo.vue?vue&type=template&id=ef791fa2&scoped=true&"
import script from "./VerticalVideo.vue?vue&type=script&lang=ts&"
export * from "./VerticalVideo.vue?vue&type=script&lang=ts&"
import style0 from "./VerticalVideo.vue?vue&type=style&index=0&id=ef791fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef791fa2",
  null
  
)

export default component.exports